import { Module } from "vuex";
import { make } from "vuex-pathify";

import { RootState } from "@/services/store/root-state";

import { actions } from "./sdg-rating.actions";
import { ISDGState } from "./sdg-rating.types";

const state: ISDGState = {
  loading: false,
  error: undefined,
  data: {
    rating: undefined,
    impact: {
      targets: [],
    },
  },
};

export const profileSDGRating: Module<ISDGState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations: make.mutations(state),
  getters: make.getters(state),
};
